import Vue from 'vue';
import App from '@/App.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueCookies from 'vue-cookies';

import globalHelper from "@/global";
import i18n from "@/i18n";
import store from '@/store';
import router from '@/router';
import Logger from '@/components/Logger';
import Tracker from '@/components/Tracker';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/global.css';

Vue.config.productionTip = false;

const vue = new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
});

// Global
Vue.mixin(globalHelper);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);

Vue.prototype.$log = new Logger();
Vue.prototype.$tracker = new Tracker();

vue.$mount('#app');
